import { MachineEventTypeEnum } from "../enums/MachineEventTypeEnum";

export class MachineEvent {
    id: number;
    machineInstallationName: string;
    machineSerialNumber: string;
    eventTimestamp: Date;
    receivedAt: Date;
    eventType: MachineEventTypeEnum;
    extraData: {};

    constructor() {}

    public parse(obj: any) {
        if (obj.Id != null && obj.Id != undefined) this.id = obj.Id;
        if (obj.MachineInstallationName) this.machineInstallationName = obj.MachineInstallationName;
        if (obj.MachineSerialNumber) this.machineSerialNumber = obj.MachineSerialNumber;
        if (obj.EventTimestamp) this.eventTimestamp = obj.EventTimestamp;
        if (obj.ReceivedAt != null) this.receivedAt = obj.ReceivedAt;
        if (obj.EventType != null && obj.EventType != undefined) this.eventType = obj.EventType;
        if (obj.ExtraDataJSON) this.extraData = JSON.parse(obj.ExtraDataJSON);
    }
}
